import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import LabeledField from '@zr/components/Fields/LabeledField';

import { formatVeteran } from '@zr/utilities/form/formatters';
import { normalizeVeteranPatch } from '@zr/utilities/form/normalizers';

import FormActions from '../../../components/FormActions';
import QuestionLabel from '../../../components/QuestionLabel';

import IndexedLegend from './IndexedLegend';
import FormButtons from './FormButtons';

import { patchProfileForm } from './utilities';

const IS_VETERAN = 'is_veteran';

export function VeteranStatus({
  index, onContinue, onSkip, submitButtonText, totalScreeningQuestions,
  isInJs6650Test, setIsLoading,
}) {
  const handleContinue = async (values, formik) => {
    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading(true);
    await patchProfileForm({
      [IS_VETERAN]: normalizeVeteranPatch(values[IS_VETERAN]),
    }, formik, onContinue);
  };

  return (
    <Formik
      initialValues={{ [IS_VETERAN]: '' }}
      onSubmit={handleContinue}
      validationSchema={Yup.object().shape({
        [IS_VETERAN]: Yup.string().required('Please select your veteran status'),
      })}
    >
      {({
        errors, handleChange, handleSubmit, isSubmitting, touched, values,
      }) => (
        <form className="Suggestion" onSubmit={handleSubmit}>
          <fieldset>
            {isInJs6650Test && (
              <QuestionLabel
                as="legend"
                html="Please confirm your veteran status."
                number={index}
                totalQuestions={totalScreeningQuestions}
              />
            )}
            {!isInJs6650Test && (
              <IndexedLegend index={index} text="Please confirm your veteran status." />
            )}
            <LabeledField
              as="select"
              input={{
                disabled: isSubmitting,
                name: IS_VETERAN,
                onChange: handleChange,
                value: formatVeteran(values[IS_VETERAN]),
              }}
              label="Veteran Status"
              meta={{
                error: errors[IS_VETERAN],
                touched: touched[IS_VETERAN],
              }}
              placeholder="Veteran Status"
            >
              <option value="true">I am a Veteran</option>
              <option value="false">I do not wish to specify at this time</option>
            </LabeledField>
            {isInJs6650Test && (
              <FormActions
                disableContinue={isSubmitting}
                disableSkip={isSubmitting}
                onSkip={onSkip}
                submitButtonText={submitButtonText}
              />
            )}
            {!isInJs6650Test && (
              <FormButtons disabled={isSubmitting} onSkip={onSkip} submitButtonText={submitButtonText} />
            )}
          </fieldset>
        </form>
      )}
    </Formik>
  );
}

VeteranStatus.propTypes = {
  index: PropTypes.number.isRequired,
  isInJs6650Test: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  setIsLoading: PropTypes.func,
  submitButtonText: PropTypes.string,
  totalScreeningQuestions: PropTypes.number.isRequired,
};

VeteranStatus.defaultProps = {
  isInJs6650Test: false,
  onSkip: null,
  setIsLoading: () => {},
  submitButtonText: 'Continue',
};

export default VeteranStatus;
